var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { border, display, height, width } from 'styled-system';
import { ResponsiveLazyImage, } from '../../common/components/LazyImage';
import { Link } from '../../common/components/Link';
import { Flex } from '../../common/components/Flex';
import { borderRadiusBL, borderRadiusBR, } from '../../common/theme/system-utilities';
import { CardTextBlock } from './CardTextBlock';
var CardLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, height);
CardLink.defaultProps = {
    display: 'flex',
    height: '100%',
    width: 1,
};
var CardPicture = styled(ResponsiveLazyImage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), width);
CardPicture.defaultProps = {
    width: 1,
};
var CardContent = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), borderRadiusBL, borderRadiusBR, border, width);
CardContent.defaultProps = {
    as: 'article',
    flexDirection: 'column',
    borderRadiusBL: 'br_3',
    borderRadiusBR: 'br_3',
    width: 1,
    border: 1,
};
export var Card = function (_a) {
    var href = _a.href, subline = _a.subline, headline = _a.headline, image = _a.image;
    return (React.createElement(CardLink, { href: href, "aria-label": headline || subline },
        React.createElement(CardContent, null,
            React.createElement(CardPicture, __assign({}, image)),
            (headline || subline) && (React.createElement(CardTextBlock, { headline: headline, subline: subline })))));
};
var templateObject_1, templateObject_2, templateObject_3;
